module.exports = __webpack_public_path__ + "static/media/IMG_7263_DxO.ec81dda8.JPG";